@if (paymentAccount?.expired || paymentAccount?.expiring) {
  <div class="error-600-text">
    <span class="icon-alert"></span>
    @if (paymentAccount?.expired) {
      <span
        data-cy="expiredPaymentAccountErrorText"
        dsContent
        [contentPath]="'billing.expiredExpiringCCDC.expiredExpiringWarning'"
        [options]="{ status: 'expired' }"
      ></span>
    }
    @if (paymentAccount?.expiring) {
      <span
        dsContent
        [contentPath]="'billing.expiredExpiringCCDC.expiredExpiringWarning'"
        [options]="{ status: 'expiring soon' }"
      ></span>
    }
    <span>
      <a
        class="error-600-text underline"
        [dsRouterLink]="[billingPaths.EDIT_PAYMENT_ACCOUNT, paymentAccount.paymentAccountId]"
        dsContent
        [contentPath]="'billing.expiredExpiringCCDC.expiredExpiringLinkText'"
      >
      </a>
      <span dsContent [contentPath]="'billing.expiredExpiringCCDC.expiredExpiringLinkPost'"></span>.
    </span>
  </div>
}
